import {
  DetailedHTMLProps,
  FormHTMLAttributes,
  forwardRef,
  ForwardRefRenderFunction,
  useImperativeHandle,
  useRef,
} from "react";

type FormProps = DetailedHTMLProps<FormHTMLAttributes<HTMLFormElement>, HTMLFormElement>

export type BriefFormRef = {
  submit: () => void
} | null

// Simulating a submit button click is still the only widely supported way to submit a form
// AND validate the nested inputs.

const _Form: ForwardRefRenderFunction<BriefFormRef, FormProps> = (
    {children, ...props}, ref
  ) => {
  const submitButtonRef = useRef<HTMLInputElement>(null)
  useImperativeHandle(ref, () => ({
    submit: () => submitButtonRef?.current?.click(),
  }));

  return (
    <form {...props}>
      <input
        type='submit'
        ref={submitButtonRef}
        className='visually-hidden'
        aria-hidden='true'
        tabIndex={-1}
        id={`${props.id}-submit-trigger`}
        />
      { children }
    </form>
  )
}

const Form = forwardRef(_Form)

export default Form